import { faDigits } from '../../lib/numerals'
import { lessonName } from './lessonTitle'

// ─── Confirmations before what the panel cannot take back ─────────────────────
//
// One place for the question the panel asks before an action that reaches
// learners at once or cannot be undone from here: publishing or archiving a
// lesson, a manual score, a broadcast. The browser's own dialog on purpose —
// it is keyboard- and screen-reader-accessible and Esc cancels — the same
// one the calendar already used for publishing.

/** Asks `message`; true only when the admin answered yes. `ask` is `window.confirm`, injectable for tests. */
export function confirmed(message, ask = globalThis.confirm) {
  return typeof ask === 'function' && ask(message) === true
}

export function publishQuestion(lesson) {
  return `«${lessonName(lesson)}» همین حالا برای همهٔ کاربران منتشر شود؟`
}

export function archiveQuestion(lesson) {
  return `«${lessonName(lesson)}» بایگانی شود؟ از فهرست درس‌ها و مسیر زبان‌آموزان برداشته می‌شود و از همین پنل برگشت‌پذیر نیست.`
}

/** `score` is the number as typed and validated (Latin digits); the question shows it in Persian ones. */
export function manualScoreQuestion(score) {
  return `امتیاز ${faDigits(score)} برای این تلاش ثبت شود؟ همین عدد به‌جای همهٔ زیرامتیازها می‌نشیند و برگشت‌پذیر نیست.`
}

export function broadcastQuestion({ title, body, recipientCount }) {
  return [
    `این اعلان برای ${faDigits(recipientCount)} کاربر در صندوق اعلان ثبت و روی گوشی‌شان پوش می‌شود و پس‌گرفتنی نیست:`,
    '',
    `«${title}»`,
    body,
    '',
    'ارسال شود؟',
  ].join('\n')
}

/**
 * A broadcast, asked first: read how many learners it reaches
 * (`admin-notifications_audience`, which sends nothing), show that with the
 * message itself, and send only on a yes. Resolves to the broadcast's answer,
 * or `null` when the admin said no — then nothing was sent.
 */
export async function broadcastAfterConfirm(dto, { audience, broadcast }, ask) {
  const { recipientCount } = await audience()
  if (!confirmed(broadcastQuestion({ ...dto, recipientCount }), ask)) return null
  return broadcast(dto)
}
